<template>
<div :class="$attrs.class">
    <p>
        {{$attrs.text}}
    </p>
</div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>